// sekcja "Internal Application" z kartami aplikacji
// @ts-nocheck

import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { HtmlBlock } from 'components/containers/HtmlBlock';

import styles from 'theme/pages/Home/components/InternalApplication/InternalApplication.module.scss';

export const InternalApplication = () => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const applyCardBackgrounds = () => {
      if (!wrapperRef.current) {
        return;
      }

      const imageSourceElements = wrapperRef.current.querySelectorAll('.application-card__background-image-src');
      imageSourceElements.forEach((element) => {
        const imageUrl = element.getAttribute('data-background-image-src');
        const cardElement = element.closest('.application-card') as HTMLElement | null;

        if (!cardElement) {
          return;
        }

        if (imageUrl) {
          cardElement.style.backgroundImage =
            `linear-gradient(177.08deg, rgba(25, 133, 196, 0) 60%, rgba(25, 133, 196, 0.6) 80%, rgba(25, 133, 196, 0.8) 100%), url("${imageUrl}")`;
        }
      });
    };

    applyCardBackgrounds();

    const observer = new MutationObserver(() => {
      applyCardBackgrounds();
    });

    if (wrapperRef.current) {
      observer.observe(wrapperRef.current, { childList: true, subtree: true });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Home-components-InternalApplication'
      )}>
      <HtmlBlock
        sectionId="HOMEPAGE_INTERNAL_APPLICATION"
        articleId="HOMEPAGE_INTERNAL_APPLICATION_SECTION"
        hasSeoTitle
      />
    </div>
  );
};

export default InternalApplication;

